<template>
    <div>
        <div style="display: none;">
            <PartyEditor v-if="selectedEmisor" ref="partyEditor" title="Editar Emisor" :party="selectedEmisor"
                :readonly="false" :emisor="true" :allow_refresh="true" :company_id="companydbId" @close="closeEditor"
                @save_company_as_party="saveEmisor" />
        </div>

        <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="3000" top>
            {{ snackbarMessage }}
            <template v-slot:action="{ attrs }">
                <v-btn text v-bind="attrs" @click="snackbar = false">
                    Cerrar
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
import { client, sync_command_dispatcher } from '@/api/client';
import { Party } from '@/modules/facturae/domain/Invoiceable';
import PartyEditor from '@/components/PartyEditor.vue';

export default {
    name: 'PopUpEmisor',
    components: {
        PartyEditor
    },
    props: {
        companydbId: {
            type: [Number, String],
            required: true
        }
    },
    data() {
        return {
            loading: false,
            selectedEmisor: null,
            snackbar: false,
            snackbarMessage: '',
            snackbarColor: 'success'
        };
    },
    methods: {
        async openEditor() {
            await this.loadEmisor();
        },
        closeEditor() {
            this.selectedEmisor = null;
        },
        async saveEmisor(party) {
            try {
                party.company_id = typeof this.companydbId === 'string' ? parseInt(this.companydbId) : this.companydbId;

                const userId = this.$store.state.me && this.$store.state.me.id;
                const response = await sync_command_dispatcher.dispatch('save.company.as.party', {
                    supplier: party,
                    user_id: userId
                });

                if (response.output.status === 'ok') {
                    this.snackbarMessage = 'Emisor guardado correctamente';
                    this.snackbarColor = 'success';
                    this.snackbar = true;

                    const currentCompany = this.$store.state.currentCompany;
                    if (currentCompany) {
                        this.$store.commit('SET_CURRENT_COMPANY', {
                            ...currentCompany,
                            configuration: {
                                ...currentCompany.configuration,
                                company_as_party: party.toPrimitive(party)
                            }
                        });
                    }

                    this.closeEditor();
                    return true;
                } else {
                    this.snackbarMessage = response.output.message || 'Error al guardar el emisor';
                    this.snackbarColor = 'error';
                    this.snackbar = true;
                    return false;
                }
            } catch (error) {
                console.error('Error guardando emisor:', error);

                this.snackbarMessage = 'Error al guardar el emisor';
                this.snackbarColor = 'error';
                this.snackbar = true;
                return false;
            }
        },
        createPartyFromCompany(currentCompany) {
            const companyData = (currentCompany.configuration && currentCompany.configuration.company_as_party) || {};

            // AutoComplete with company data and fill with currentCompany data if not exists in companyData
            const supplier = new Party({
                id: 0,
                company_id: currentCompany.id,
                cif: companyData.cif || currentCompany.cif || "",
                post_code: companyData.post_code || "",
                type: companyData.type || "juridica",
                name: companyData.name || currentCompany.name || "",
                first_surname: companyData.first_surname || "",
                second_surname: companyData.second_surname || "",
                business_name: companyData.business_name || currentCompany.name || "",
                trade_name: companyData.trade_name || currentCompany.name || "",
                address: companyData.address || "",
                city: companyData.city || "",
                province: companyData.province || "",
                email: companyData.email || "",
                phone: companyData.phone || "",
                website: companyData.website || ""
            });

            supplier.bank_account_number = companyData.bank_account_number || "";
            supplier.bic = companyData.bic || "";
            supplier.mandate_id = companyData.mandate_id || "";

            return supplier;
        },
        async loadEmisor() {

            this.loading = true;

            try {

                const response = await client.get(`companydbs_detail/${this.companydbId}/`);

                if (!response.data) {
                    throw new Error('No se pudieron cargar los datos de la empresa');
                }

                this.$store.commit('SET_CURRENT_COMPANY', response.data);

                const emisorParty = this.createPartyFromCompany(response.data);

                this.selectedEmisor = emisorParty;

                this.$nextTick(() => {
                    if (this.$refs.partyEditor) {
                        this.$refs.partyEditor.openPartyEditor();
                    }
                });

            } catch (error) {
                console.error('Error cargando emisor:', error);
                this.snackbarMessage = 'Error al cargar el emisor';
                this.snackbarColor = 'error';
                this.snackbar = true;
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>

<style scoped>
.primary_blue {
    background-color: var(--v-primary_blue-base) !important;
}
</style>
